var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ticksouter",staticClass:"flex justify-between items-center flex-1"},[(_vm.initd3)?_c('div',{staticClass:"absolute w-full opacity-50",attrs:{"id":"ticksvg"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }